import * as actionTypes from './actions';

export const initialState = {
    // read stored value so initial state reflects server/check results
    rekycRequired: localStorage.getItem('rekycRequired') === 'true'
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_REKYC_REQUIRED:
            return {
                ...state,
                rekycRequired: action.payload
            };
        default:
            return state;
    }
};

export default authReducer;
